export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Projects-Typing-speed-testing-960.891b7412.webp";